// 隐私政策授权状态（应用市场审核要求：首次打开必须先弹隐私政策弹窗，同意前不收集任何个人信息）
const STORAGE_KEY = 'privacy_consent_accepted'

export const hasPrivacyConsented = () => {
  try {
    return localStorage.getItem(STORAGE_KEY) === 'true'
  } catch (e) {
    return false
  }
}

export const setPrivacyConsented = () => {
  try {
    localStorage.setItem(STORAGE_KEY, 'true')
  } catch (e) {
    // 存储异常时忽略：下次启动会重新弹窗
  }
}
